import React from 'react';
import PropTypes from 'prop-types';

import { VaButtonSegmented } from '@department-of-veterans-affairs/component-library/dist/react-bindings';

const SegmentedControl = ({ label, labels, onChange, selected }) => {
  const buttons = labels.map((text, index) => ({
    label: text,
    value: String(index),
  }));

  const handleClick = event => {
    onChange?.(Number(event.detail.value));
  };

  return (
    <div
      className={`segment-wrapper ${
        selected === 0 ? 'segment-wrapper-list' : ''
      }`}
    >
      <VaButtonSegmented
        label={label}
        buttons={buttons}
        selected={selected}
        onVaButtonClick={handleClick}
      />
    </div>
  );
};

SegmentedControl.propTypes = {
  labels: PropTypes.array.isRequired,
  label: PropTypes.string,
  selected: PropTypes.number,
  onChange: PropTypes.func,
};

export default SegmentedControl;
